import { GenericObject } from 'core/models/platform';
import { AxiosResponse } from 'axios';
import { serializeQueryParams } from '.';
import { getConfig } from 'next';
const { publicRuntimeConfig } = getConfig();

type IApiEnabledForCache =
  | 'single-paraphrase'
  | 'single-flip'
  | 'segment3'
  | 'detect-language'
  | 'segment'
  | 'grammar-check'
  | ''
  | 'paraphrase-phrase'
  | 'friendly-tone'
  | 'formal-tone'
  | 'complex-tone';

interface IResponseCache {
  singleparaphrase: GenericObject;
  singleflip: GenericObject;
  segment3: GenericObject;
  detectlanguage: GenericObject;
  segment: GenericObject;
  grammarcheck: GenericObject;
  paraphrasephrase: GenericObject;
  formaltone: GenericObject;
  friendlytone: GenericObject;
  complextone: GenericObject;
}

type KeyOfIResponseCache = keyof IResponseCache;

class CacheManager {
  private static instance: CacheManager;

  isDefaultTextLoaded = false;

  responseCache: IResponseCache = {
    singleparaphrase: {},
    singleflip: {},
    segment3: {},
    detectlanguage: {},
    segment: {},
    grammarcheck: {},
    paraphrasephrase: {},
    formaltone: {},
    friendlytone: {},
    complextone: {},
  };

  apisEnabledForCache: IApiEnabledForCache[] = [
    'single-paraphrase',
    'single-flip',
    'segment3',
    'detect-language',
    'segment',
    'grammar-check',
    'paraphrase-phrase',
    'formal-tone',
    'friendly-tone',
    'complex-tone',
  ];

  static getInstance(): CacheManager {
    if (!CacheManager.instance) CacheManager.instance = new CacheManager();
    return CacheManager.instance;
  }

  getApiNameFromUrl(url: string) {
    let apiName = '';
    this.apisEnabledForCache.forEach((name: IApiEnabledForCache) => {
      if (url.indexOf(name) !== -1) apiName = name;
    });

    if (!this.isDefaultTextLoaded) {
      const cacheResponse = fetch(`${publicRuntimeConfig.ASSETS_URL}/jsonData/default_text.json`);
      cacheResponse
        .then((res) => res.json())
        .then((result) => {
          this.isDefaultTextLoaded = true;
          const cacheStored = result.default;
          this.responseCache.singleparaphrase = cacheStored.singleparaphraseResponse;
          this.responseCache.segment3 = cacheStored.segment3Response;
          this.responseCache.singleflip = cacheStored.singleflipResponse;
        });
    }
    return apiName as IApiEnabledForCache;
  }

  get(url: string, params?: GenericObject) {
    if (!params) return null;

    const apiName = this.getApiNameFromUrl(url);
    if (apiName === '') return null;
    const cacheKey = `${url}?${serializeQueryParams(params)}`;
    if (cacheKey === '') return null;

    return this.responseCache[<KeyOfIResponseCache>apiName.replace('-', '')][cacheKey]
      ? JSON.parse(this.responseCache[<KeyOfIResponseCache>apiName.replace('-', '')][cacheKey] as string)
      : null;
  }

  set = (url: string, response: AxiosResponse<GenericObject> | Array<GenericObject>, params?: GenericObject) => {
    if (!params) return;

    const apiName = this.getApiNameFromUrl(url);

    //  Not caching the single para response for creative mode , Validating if the
    //  response array contain modeId with rejection_sampling in it then we are not caching the response.
    const responseStore = response as Array<GenericObject>;

    if (apiName.includes('single-para') && Array.isArray(responseStore)) {
      const modelId = responseStore[0]?.MODEL_ID || '';
      if (modelId.includes('rejection_sampling')) return;
      // don't cache when the beam count in response is less than 3 (generally will happen in case of premium modes response)
      const paraMode = +url.slice(-1);
      const responseBeamKey = `paras_${paraMode + 1}`;
      if (paraMode && responseStore[0] && responseStore[0][responseBeamKey]?.length < 3) return;

      // const BeamLength = responseStore[0]?.paras_5?.length;
      //      if (BeamLength && BeamLength < 5) return;
    }

    if (apiName !== '') {
      const cacheKey = `${url}?${serializeQueryParams(params)}`;
      if (cacheKey !== '') {
        this.responseCache[<KeyOfIResponseCache>apiName.replace('-', '')][cacheKey] = JSON.stringify(response);
      }
    }
  };
}

export default CacheManager;

export { CacheManager };
